import { makeStyles } from "@material-ui/core";
// eslint-disable-next-line import/no-cycle
import { useCongress } from ".";

const useCongressStyle = () => {
  const { congress } = useCongress();
  return makeStyles(() => ({
    congress: {
      color: congress.buttonTextColor,
      backgroundColor: congress.buttonColor
    }
  }));
};

export default useCongressStyle;
